/** Client-side merge of ContentTranslation rows into CMS payloads (fallback JSON). */

export const setByPath = (target, path, value) => {
  if (!target || !path) return;
  const parts = path.split('.');
  let cur = target;
  for (let i = 0; i < parts.length - 1; i++) {
    const part = parts[i];
    const idx = Number(part);
    if (cur == null || typeof cur !== 'object') return;
    if (Array.isArray(cur) && !Number.isNaN(idx)) {
      if (cur[idx] == null) return;
      cur = cur[idx];
    } else {
      if (cur[part] == null) return;
      cur = cur[part];
    }
  }
  const last = parts[parts.length - 1];
  const lastIdx = Number(last);
  if (cur && typeof cur === 'object') {
    if (Array.isArray(cur) && !Number.isNaN(lastIdx)) cur[lastIdx] = value;
    else cur[last] = value;
  }
};

const clone = (payload) => {
  try {
    return JSON.parse(JSON.stringify(payload));
  } catch {
    return payload;
  }
};

/** Apply translation rows to a singleton object (hero, footer, etc.). */
export const applySingletonTranslations = (payload, items, entityId = 'singleton') => {
  if (!payload || !items?.length) return payload;
  const out = clone(payload);
  items.forEach(({ entity_id, field_path, value }) => {
    if (entity_id && entity_id !== entityId) return;
    setByPath(out, field_path, value);
  });
  return out;
};

/** Apply translation rows to an object keyed by field name (property/project inputs fallback). */
export const applyFieldKeyedTranslations = (payload, items) => {
  if (!payload || !items?.length) return payload;
  const out = clone(payload);
  items.forEach(({ entity_id, field_path, value }) => {
    if (!entity_id || !out[entity_id]) return;
    setByPath(out[entity_id], field_path, value);
  });
  return out;
};

/** Fetch overlay translations and merge into fallback when API has no DB record. */
export const mergeContentTranslations = async (api, entity, locale, payload, options = {}) => {
  if (!payload || !entity || !locale || locale === 'en') return payload;
  try {
    const res = await api.get(`/localization/content/${entity}`, { params: { locale } });
    const items = res.data?.items || [];
    if (!items.length) return payload;
    if (options.keyedByField) return applyFieldKeyedTranslations(payload, items);
    return applySingletonTranslations(payload, items, options.entityId || 'singleton');
  } catch {
    return payload;
  }
};
